
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useProject } from "@/hooks/useProject";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DeleteClientDialogProps {
  client: any;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteClientDialog({ client, open, onOpenChange }: DeleteClientDialogProps) {
  const queryClient = useQueryClient();
  const { projectClient, currentProject } = useProject();

  const handleDelete = async () => {
    try {
      // Delete logo if exists
      if (client.logo) {
        await supabase.storage
          .from('client-logos')
          .remove([client.logo]);
      }
      
      const { error } = await projectClient
        .from('clientes')
        .delete()
        .eq('id', client.id)
        .eq('project_id', projectClient.getProjectId());
      
      if (error) throw error;
      
      toast.success('Cliente eliminado correctamente');
      queryClient.invalidateQueries({ queryKey: ['clients', currentProject] });
      onOpenChange(false);
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Eliminar Cliente</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p>¿Estás seguro de que deseas eliminar a {client.nombre}?</p>
          <div className="flex justify-end space-x-2">
            <Button variant="ghost" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button variant="destructive" onClick={handleDelete}>
              Eliminar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
